<template>
    <div class="modal fade" id="createCoordinationFromOrgDocumentsModal" tabindex="-1" role="dialog" aria-labelledby="createCoordinationModalLabel" aria-hidden="true" data-backdrop="static">
        <div class="modal-dialog modal-xl" role="document">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title" id="createCoordinationModalLabel">{{ $t('coordinations.newCoordination') }}</h5>
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <div class="loader" v-if="isSaving"></div>
                <form @submit="onSubmit" v-show="!isSaving">
                    <div class="modal-body" v-if="showEditor">
                        <div class="form-group">
                            <div class="font-weight-bold required">{{$t('coordinations.title')}}</div>
                            <div class="w-100">
                                <input class="form-control"
                                    v-model="model.title"
                                    v-validate="'required'"
                                    :name="'title'+_uid"
                                    :data-vv-as="$t('coordinations.title')"
                                />
                                <span class="text-danger col-12"
                                    v-if="errors.has('title'+_uid)">
                                    {{ errors.first('title'+_uid) }}
                                </span>
                            </div>
                        </div>
                        <div class="form-group">
                            <div class="font-weight-bold required">{{$t('request_n')}}</div>
                            <div>
                                <textarea class="form-control w-100"
                                    :name="'textarea'+_uid"
                                    :data-vv-as="$t('request_n')"
                                    v-model="model.request"
                                    v-validate="'required'"
                                />
                                <span class="text-danger col-12" v-if="errors.has('textarea'+_uid)">{{ errors.first('textarea'+_uid) }}</span>
                            </div>
                        </div>
                        <div class="form-group">
                            <div class="font-weight-bold">{{$t('coordinations.requestLink')}}</div>
                            <div>
                                <input  class="form-control"  type="text" v-model="model.itemLink">
                            </div>
                        </div>
                        <div class="form-group">
							<div class="font-weight-bold required">{{$t('coordinations.coordinators')}}</div>
							<Coordinators
                                v-model="model.coordinators"
                                api-url="api/user/searchCoordinators"
                                show-all-users-btn
                            />
						</div>
                        <div class="form-group">
							<div class="required font-weight-bold pb-2">{{$t('coordinations.type')}}</div>
							<div id="task-type-choice">
								<div class="radio">
									<label>
										<input type="radio" name="optionsRadios" value="internal" v-model="model.typeId" checked />
										{{$t('coordinations.innerType')}}
									</label>
									<div class="text-info radio-message mb-2" v-if="model.typeId === 'internal'">
										<i class="fa fa-exclamation-circle"></i>
										{{$t('coordinations.innerTypeMessage')}}
									</div>
								</div>
								<div class="radio">
									<label>
										<input type="radio" name="optionsRadios" value="outgoing" v-model="model.typeId" />
										{{$t('coordinations.outgoingType')}}
									</label>
									<div class="text-info radio-message mb-2" v-if="model.typeId === 'outgoing'">
										<i class="fa fa-exclamation-circle"></i>
										{{$t('coordinations.outgoingTypeMessage')}}
									</div>
								</div>
							</div>
						</div>
                        <div class="form-group" v-if="model.typeId === 'outgoing'">
							<div class="font-weight-bold">{{$t('coordinations.clerk')}}</div>
							<SearchBox v-model="model.clerkId" apiUrl="api/user/search" ref="searchbox"></SearchBox>
						</div>
                        <div class="form-group">
                            <div class="font-weight-bold required">{{$t('tasks.deadline')}}</div>
                            <DatePicker
                                v-model="model.deadline"
                                :min="new Date()"
                                v-validate="'required'"
                                :data-vv-as="$t('tasks.deadline')"
                                :error="errors.first($t('tasks.deadline'))"
                                :fieldName="$t('tasks.deadline')"
                            ></DatePicker>
                        </div>

                        <div class="form-group">
                            <div class="font-weight-bold">{{$t('coordinations.attachments')}}</div>
                            <div v-if="selectedItems">
                                <div class="mb-2" v-for="(item, index) in selectedItems" :key="index">
                                    <div>{{ item.fileName }}</div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="modal-footer">
                        <button type="submit" class="btn btn-primary" :disabled="!model || !model.coordinators || !model.coordinators.length">{{$t('buttons.save.btnText')}}</button>
                        <button type="button" class="btn btn-secondary" data-dismiss="modal">{{$t('buttons.cancel')}}</button>
                    </div>
                </form>
            </div>
        </div>
    </div>
</template>

<script>
/* eslint-disable */
import DatePicker from '../datepicker/DateTimePicker';
import Coordinators from '@/components/coordinations/coordinators-list';
import SearchBox from '@/components/common/SearchBox';


import { Coordination } from '@/models/models';
import coordinationService from '@/services/coordinations.service';

export default {
    components: {
        Coordinators,
        DatePicker,
        SearchBox
    },
    props: {
        selectedItems: { type: Array, default() { return null; } },
        show: {
            type: Boolean,
            default: true
        }
    },
    data() {
        return {
            model: new Coordination(),
            isSaving: false,
            filesNames: [],
            showEditor: true
        };
    },
    methods: {
        onSubmit(e) {
            e.preventDefault();
            if (this.model.coordinators.length) {
                this.$validator.validate().then(valid => {
                    if (valid) {
                        this.save();
                    } else {
                        console.log('Form not valid');
                    }
                });
            }
        },
        save() {
            this.isSaving = true;

            const payload = {
                title: this.model.title,
                request: this.model.request,
                deadline: this.model.deadline ? this.model.deadline.toJSON() : undefined,
                typeId: this.model.typeId,
                clerkId: this.model.clerkId,
                itemLink: this.model.itemLink,
                organizationalDocuments: this.selectedItems.map(x => x.organizationalDocumentId),
                coordinators: this.model.coordinators.map(x => x.userId)
            };

            coordinationService
                .createFromOrganizationalDocuments(payload)
                .then(() => {
                    this.$vs.notify({
                        color: 'success',
                        title: this.$t('createSuccess'),
                        text: ''
                    });
                    this.$emit('updated', this.model);
                    this.hide();
                })
                .catch(err => {
                    this.$vs.notify({
                        color: 'danger',
                        title: this.$t('notifications.error'),
                        text: this.$helpers.errorText(err)
                    });
                })
                .then(() => (this.isSaving = false));
        },
        onClose() {
            this.$emit('update:show', false);
            this.$emit('onClose');
            this.isSaving = false;
            this.model = new Coordination();
            this.showEditor = false;
            this.$validator.reset();
        },
        hide() {
            $(this.$el).modal('hide');
        },
        mountModel() {
            $('#task-type-choice').bootstrapMaterialDesign();
        },
    },
    mounted() {
        // add modal close listener
        $(this.$el).on('hidden.bs.modal', this.onClose);
        $(this.$el).on('shown.bs.modal', this.mountModel);
    },
    beforeDestroy() {
        // remove listener
        $(this.$el).off('hidden.bs.modal');
    },
    watch: {
        show: function (val) {
            if (val) {
                this.showEditor = true;
            }
            this.model = new Coordination();
        }
    }
};
</script>

<style lang="scss" scoped>
.radio-message {
    padding: 3px 3px 3px 5px;
    border-left: 3px solid #03a9f4;
    box-shadow: 1px 1px 1px 1px lightgrey;
}

div.radio label {
    color: inherit;
    cursor: pointer;
}

.bmd-form-group {
    padding-top: 1rem !important;
}
</style>
